import { create } from "zustand";
import { persist } from "zustand/middleware";
import { type OccasionTheme, getAutoTheme } from "./theme-config.ts";

interface ThemeState {
  theme: "light" | "dark";
  occasionTheme: OccasionTheme;
  isAutoTheme: boolean;
  isBirthday: boolean;
  setTheme: (theme: "light" | "dark") => void;
  setOccasionTheme: (theme: OccasionTheme) => void;
  setAutoTheme: () => void;
  setBirthday: (isBirthday: boolean) => void;
  resetToAuto: () => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: "light",
      occasionTheme: "caelius-classic",
      // occasionTheme: getAutoTheme(),
      // isAutoTheme: true,
      isAutoTheme: false,
      isBirthday: false,

      setTheme: (theme) => set({ theme }),

      setOccasionTheme: (theme) =>
        set({ occasionTheme: theme, isAutoTheme: false }),

      setAutoTheme: () =>
        set((state) => {
          const auto = state.isBirthday ? "birthday" : getAutoTheme();
          return { occasionTheme: auto, isAutoTheme: true };
        }),

      setBirthday: (isBirthday) =>
        set((state) => {
          if (isBirthday && state.isAutoTheme) {
            return { isBirthday, occasionTheme: "birthday" };
          }
          return { isBirthday };
        }),

      resetToAuto: () => {
        const auto = getAutoTheme();
        set({ occasionTheme: auto, isAutoTheme: true });
      },
    }),
    {
      name: "caelius-one-theme",
      partialize: (state) => ({
        theme: state.theme,
        occasionTheme: state.occasionTheme,
        isAutoTheme: state.isAutoTheme,
      }),
    },
  ),
);
